import React, { useContext, useEffect, useState } from "react";
import { HashLink } from "react-router-hash-link";
import { AppContext } from "../../../Contexts/AppContext";

const Hero = () => {
  const context = useContext(AppContext);
  const [currentBG, setCurrentBG] = useState("");
  const [currentText, setCurrentText] = useState("");
  const [currentColor, setCurrentColor] = useState("");

  useEffect(() => {
    setCurrentBG(
      context.isLight
        ? context.currentTheme["business"].bg
        : context.currentTheme["business"].dark_bg
    );
    setCurrentText(
      context.isLight
        ? context.currentTheme["business"].text
        : context.currentTheme["business"].dark_text
    );
    setCurrentColor(
      context.isLight
        ? context.currentTheme["business"].dropdown
        : context.currentTheme["business"].dark_dropdown
    );
  }, [context]);
  return (
    <div
      style={{
        backgroundColor: currentBG,
        color: currentText,
        backgroundImage: `${
          context.isLight
            ? "linear-gradient(to bottom, #f0ccffcc, #f0ccffcc)"
            : "linear-gradient(to bottom, #26172ccc, #26172ccc)"
        }, url('${
          process.env.REACT_APP_IMAGES_URL
        }/Assets/Images/Businesses/Yarn/hero.png')`,
      }}
      className="flex min-h-[calc(100vh-56px)] flex-col items-center justify-start bg-cover bg-fixed bg-center bg-no-repeat transition-all duration-500 lg:flex-row"
    >
      <div className="order-2 flex-1 px-5 lg:order-1 lg:px-10">
        <h1 className="mb-5 text-3xl font-semibold xs:text-5xl">Yarn Heaven</h1>
        <p className="text-base font-thin xs:text-xl">
          A crocheted piece is the lovely manifestation of a thought, expressed
          through hand, heart, hook & yarn.
        </p>
        <div className="flex items-center justify-between">
          <HashLink
            to="#tutorials"
            smooth
            className="my-5 w-24 rounded-full border-2 py-1 text-center text-xs transition-all xs:my-3 xs:w-32 xs:py-2 xs:text-sm ss:w-36"
            style={{
              borderColor: currentText,
              backgroundColor: currentText,
              color: currentBG,
            }}
            onMouseEnter={(e) => {
              e.target.style.borderColor = currentColor;
              e.target.style.backgroundColor = currentColor;
              e.target.style.color = currentText;
            }}
            onMouseLeave={(e) => {
              e.target.style.borderColor = currentText;
              e.target.style.backgroundColor = currentText;
              e.target.style.color = currentBG;
            }}
          >
            TUTORIALS
          </HashLink>
          <a
            href="/"
            className="my-5 w-24 rounded-full border-2 py-1 text-center text-xs transition-all xs:my-3 xs:w-32 xs:py-2 xs:text-sm ss:w-36"
            style={{ borderColor: currentText }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = currentColor;
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "unset";
            }}
          >
            VISIT US
          </a>
        </div>
      </div>
      <div className="order-1 my-5 flex flex-1 items-end px-2 xs:px-5 sm:px-10 lg:order-2 lg:my-0 lg:items-center">
        <img
          src={`${process.env.REACT_APP_IMAGES_URL}/Assets/Images/Businesses/Yarn/logo.png`}
          alt="logo"
          className="w-2/4"
        />
        <div className="m-3 ss:m-5 lg:my-0">
          <h1 className="text-lg xs:text-2xl">
            We Have 5 Different Types Of Tutorials
          </h1>
          <div className="mt-5 flex flex-col rounded-xl border-2 p-2 ss:rounded-3xl ss:p-5">
            <HashLink
              to="#tutorials"
              smooth
              className="w-fit cursor-pointer text-xs uppercase transition-all hover:scale-105 hover:font-semibold xs:text-base"
              onClick={() => {}}
            >
              🌷 Flowers
            </HashLink>
            <HashLink
              to="#tutorials"
              smooth
              className="w-fit cursor-pointer text-xs uppercase transition-all hover:scale-105 hover:font-semibold xs:text-base"
              onClick={() => {}}
            >
              👚 Top
            </HashLink>
            <HashLink
              to="#tutorials"
              smooth
              className="w-fit cursor-pointer text-xs uppercase transition-all hover:scale-105 hover:font-semibold xs:text-base"
              onClick={() => {}}
            >
              🐙 Animals
            </HashLink>
            <HashLink
              to="#tutorials"
              smooth
              className="w-fit cursor-pointer text-xs uppercase transition-all hover:scale-105 hover:font-semibold xs:text-base"
              onClick={() => {}}
            >
              🧣 Blankets
            </HashLink>
            <HashLink
              to="#tutorials"
              smooth
              className="w-fit cursor-pointer text-xs uppercase transition-all hover:scale-105 hover:font-semibold xs:text-base"
              onClick={() => {}}
            >
              👜 Bags
            </HashLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
